(function () {
  'use strict';

  document.querySelectorAll('[data-pdp-mobile-buybar]').forEach((bar) => {
    const target = document.getElementById(bar.dataset.pdpMobileTarget);
    const sourceButton = target?.querySelector('[data-add-button]');
    const button = bar.querySelector('[data-pdp-mobile-add]');
    const buttonLabel = bar.querySelector('[data-pdp-mobile-add-label]');
    const feedback = bar.querySelector('[data-pdp-mobile-feedback]');
    const quantitySummary = bar.querySelector('[data-pdp-mobile-quantity]');
    const priceSummary = bar.querySelector('[data-pdp-mobile-price]');
    const unitSummary = bar.querySelector('[data-pdp-mobile-unit-price]');
    const planLabel = bar.querySelector('[data-pdp-mobile-plan-label]');
    const purchaseToggle = bar.querySelector('[data-pdp-mobile-purchase-toggle]');
    const purchaseTray = bar.querySelector('[data-pdp-mobile-purchase-tray]');
    const purchaseChoices = Array.from(bar.querySelectorAll('[data-pdp-mobile-purchase-choice]'));
    const footer = document.querySelector('.site-footer');
    const suppressors = document.querySelectorAll('[data-pdp-mobile-buybar-suppress]');
    if (!target || !sourceButton || !button || !quantitySummary || !priceSummary || !purchaseToggle || !purchaseTray) return;

    const purchaseOptions = Array.from(target.querySelectorAll('[data-purchase-option]'));
    const isSubscriptionOption = (option) => option.hasAttribute('data-subscription-option') || Boolean(option.dataset.sellingPlanId);
    const onceOption = purchaseOptions.find((option) => !isSubscriptionOption(option));
    const subscriptionOption = purchaseOptions.find(isSubscriptionOption);
    const canSwitchPurchase = Boolean(onceOption && subscriptionOption);
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: target.dataset.currency || 'USD'
    }).format(cents / 100);
    const amount = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : null;

    // BOOST lets shoppers read the purchase choices before a sticky bar can cover them.
    const showOnlyAfterCta = target.hasAttribute('data-buybar-after-cta');
    const BAR_CLEARANCE = 90;
    const isCtaOffscreen = (rect) => rect.bottom < 0 || (!showOnlyAfterCta && rect.top > window.innerHeight - BAR_CLEARANCE);
    let primaryCtaOffscreen = false;
    let footerVisible = false;
    const visibleSuppressors = new Set();

    const updateVisibility = () => {
      const visible = primaryCtaOffscreen && !footerVisible && visibleSuppressors.size === 0;
      if (!visible) setPurchaseSelector(false);
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      bar.inert = !visible;
      button.tabIndex = visible ? 0 : -1;
      purchaseToggle.tabIndex = visible && canSwitchPurchase ? 0 : -1;
    };

    const setPurchaseSelector = (open, restoreFocus = false) => {
      const nextOpen = Boolean(open && canSwitchPurchase);
      bar.classList.toggle('is-selector-open', nextOpen);
      purchaseToggle.setAttribute('aria-expanded', String(nextOpen));
      purchaseTray.setAttribute('aria-hidden', String(!nextOpen));
      purchaseTray.inert = !nextOpen;
      purchaseChoices.forEach((choice) => { choice.tabIndex = nextOpen ? 0 : -1; });
      if (nextOpen) {
        window.requestAnimationFrame(() => purchaseChoices.find((choice) => choice.getAttribute('aria-pressed') === 'true')?.focus());
      } else if (restoreFocus && bar.classList.contains('is-visible')) {
        purchaseToggle.focus();
      }
    };

    const updateSummary = () => {
      const quantity = target.querySelector('[data-quantity-option]:checked');
      const purchaseOption = target.querySelector('[data-purchase-option]:checked');
      const quantityValue = Number(quantity?.value || 1);
      const subscription = Boolean(purchaseOption?.dataset.sellingPlanId);
      const total = amount(subscription ? purchaseOption.getAttribute('data-plan-total-' + quantityValue) : quantity?.dataset.onceTotal);
      const subscriptionDemo = target.dataset.subscriptionDemo === 'true';
      quantitySummary.textContent = quantityValue + (quantityValue === 1 ? ' tin' : ' tins');
      priceSummary.textContent = total === null ? 'See price above' : money(total);
      if (unitSummary) unitSummary.textContent = total === null ? '' : money(Math.round(total / quantityValue)) + '/tin';
      if (subscriptionDemo && unitSummary) {
        const renewal = amount(subscriptionOption?.getAttribute('data-plan-renewal-total-' + quantityValue));
        unitSummary.textContent = subscription && renewal !== null ? 'Then ' + money(renewal) + ' ' + subscriptionOption.dataset.planCadence : 'One-time purchase';
      }
      if (planLabel) planLabel.textContent = subscriptionOption?.disabled ? 'Unavailable for this tin' : subscriptionOption?.dataset.planName || '';
      const busy = sourceButton.getAttribute('aria-busy') === 'true';
      purchaseChoices.forEach((choice) => {
        const selected = choice.dataset.pdpMobilePurchaseChoice === (subscription ? 'subscribe' : 'once');
        choice.disabled = busy || (choice.dataset.pdpMobilePurchaseChoice === 'subscribe' && Boolean(subscriptionOption?.disabled));
        choice.setAttribute('aria-pressed', String(selected));
      });
      button.disabled = sourceButton.disabled;
      button.setAttribute('aria-busy', String(busy));
      if (buttonLabel) buttonLabel.textContent = sourceButton.querySelector('[data-add-label]')?.textContent || 'Add to cart';
      purchaseToggle.disabled = busy;
      if (busy) setPurchaseSelector(false);
    };

    new IntersectionObserver(([entry]) => {
      primaryCtaOffscreen = showOnlyAfterCta ? entry.boundingClientRect.bottom < 0 : !entry.isIntersecting;
      updateVisibility();
    }, { rootMargin: '0px 0px -' + BAR_CLEARANCE + 'px 0px' }).observe(sourceButton);

    // A fast scroll can skip the CTA without changing its intersection ratio.
    let scrollFrame = 0;
    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        const rect = sourceButton.getBoundingClientRect();
        primaryCtaOffscreen = isCtaOffscreen(rect);
        updateVisibility();
      });
    }, { passive: true });

    if (footer) {
      new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        updateVisibility();
      }).observe(footer);
    }

    if (suppressors.length) {
      const suppressorObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visibleSuppressors.add(entry.target);
          else visibleSuppressors.delete(entry.target);
        });
        updateVisibility();
      // Hide BOOST's bar as soon as an in-page purchase action enters the viewport.
      }, { rootMargin: showOnlyAfterCta ? '0px' : '0px 0px -84px 0px' });
      suppressors.forEach((element) => suppressorObserver.observe(element));
    }

    target.addEventListener('change', () => window.requestAnimationFrame(updateSummary));
    target.addEventListener('pdp:purchase-change', updateSummary);
    target.addEventListener('pdp:cart-status', (event) => {
      if (!feedback) return;
      feedback.hidden = event.detail.state !== 'error';
      feedback.querySelector('[data-pdp-mobile-feedback-text]').textContent = event.detail.message;
    });
    bar.querySelector('[data-pdp-mobile-review-options]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const options = target.querySelector('.sp-buy__tiles');
      options?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      target.querySelector('[data-quantity-option]:checked')?.focus({ preventScroll: true });
    });
    button.addEventListener('click', () => sourceButton.click());
    purchaseToggle.hidden = !canSwitchPurchase;
    purchaseToggle.addEventListener('click', () => setPurchaseSelector(purchaseToggle.getAttribute('aria-expanded') !== 'true'));
    purchaseChoices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const option = choice.dataset.pdpMobilePurchaseChoice === 'subscribe' ? subscriptionOption : onceOption;
        if (!option || option.disabled) return;
        option.checked = true;
        option.dispatchEvent(new Event('change', { bubbles: true }));
        setPurchaseSelector(false, true);
      });
    });
    document.addEventListener('click', (event) => {
      if (!bar.contains(event.target)) setPurchaseSelector(false);
    });
    bar.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && purchaseToggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setPurchaseSelector(false, true);
      }
    });
    new MutationObserver(updateSummary).observe(sourceButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'], childList: true, subtree: true, characterData: true });
    updateSummary();
    updateVisibility();
  });
})();
